export default {
    Get: {
        GET_PRINTTEMPLATE:'getPrintTemplate',
        GET_LOOKUP_TEMPLATES:'getLookupTemplates',
        GET_LOOKUP_DOCUMENTS:'getLookupDocuments',
        GET_LOOKUP_PROPERTIES:'getLookupProperties',
        GET_LOOKUP_PROJECTS:'getLookupProjects',
        GET_LOOKUP_DEMANDS:'getLookupDemands',
        GET_LOOKUP_PERSONS:'getLookupPersons',
    },
    Set: {
        STORE_PRINTTEMPLATE: 'insertPrintTemplate',
        INIT_PRINTTEMPLATE: 'initPrintTemplate',
        UPDATE_PRINTTEMPLATE: 'updatePrintTemplate',
        UPDATE_iTEM_ARRAY_FIELD_PRINTTEMPLATE: 'updateArrayFieldPrintTemplate',
        PUSH_iTEM_ARRAY_FIELD_PRINTTEMPLATE: 'pushItemToArrayFieldPrintTemplate',
        REMOVE_ITEM_ARRAY_FIELD_PRINTTEMPLATE: 'removeItemToArrayFieldPrintTemplate',
        POST_DATA_PRINTTEMPLATE: 'postDataPrintTemplate',

        SET_LOOKUP_TEMPLATES:'setLookupTemplates',
        SET_LOOKUP_DOCUMENTS:'setLookupDocuments',
        SET_LOOKUP_PROPERTIES:'setLookupProperties',
        SET_LOOKUP_PROJECTS:'setLookupProjects',
        SET_LOOKUP_DEMANDS:'setLookupDemands',
        SET_LOOKUP_PERSONS:'setLookupPersons'
    },
    Service: {
        SEND_PRINTTEMPLATE: 'sendPrintTemplate',
        GET_LOOKUP_TEMPLATES:'getLookupTemplates',
        GET_LOOKUP_DOCUMENTS:'getLookupDocuments',
        GET_LOOKUP_DEMANDS:'getQuickSearchDemands',
        GET_LOOKUP_PERSONS:'getQuickSearchPersons',

        GET_LOOKUP_PROPERTIES:'getQuickSearchProperties',
        GET_LOOKUP_PROJECTS:'getQuickSearchProjects',
        CHECK_STATUS_PRINTTEMPLATES: 'checkPrintTemplateStatus',
    }
};